import { ApiReadProvider } from 'api-read-hook';
import * as React from 'react';

import useReader from './use-reader';

type Props = {
  children: React.ReactNode;
};

export default function RapidApiReadConfig({ children }: Props) {
  const reader = useReader();
  // ApiReadProvider is untyped upstream
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const Provider = ApiReadProvider as any;
  return <Provider config={{ reader }}>{children}</Provider>;
}
